import { render, staticRenderFns } from "./CardUpdatePage.vue?vue&type=template&id=22045205&scoped=true"
import script from "./CardUpdatePage.vue?vue&type=script&lang=js"
export * from "./CardUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22045205",
  null
  
)

export default component.exports